export default __webpack_public_path__ + "b6500906b73a0110afe90ad84a484f05.svg";